import styled from 'styled-components';
import { createGradientOrSolid } from 'utils';

export const StyledBundlePriceButton = styled.div.attrs({
  className: 'bundlePriceButton',
})`
  width: 100%;
  border-radius: 16px;
` as any;

export const StyledBundlePrice = styled.div`
  font-family: var(--font-family);
  background: ${({ bundleButtonColor }: any) =>
    bundleButtonColor && createGradientOrSolid(bundleButtonColor)};
  height: 28px;
  border-radius: 100px;
  border: 1px solid #fff9eb;
  box-shadow: 0px -1px 1.9px 0px rgba(0, 0, 0, 0.06),
    0px 3px 5px 0px rgba(251, 133, 125, 0.4);
  display: flex;
  direction: ${(props: any) => props.direction};
  justify-content: center;
  align-items: center;
  color: ${({ bundleButtonTextColor }: any) => bundleButtonTextColor};
  position: relative;
  min-width: 80px;
  width: 70%;
  padding: 0 8px;
  box-sizing: border-box;

  .totalPrice {
    display: flex;
    justify-content: center;
    z-index: 10;
    white-space: nowrap;
    font-weight: 700;
    width: 100%;
    font-size: 16px;

    .actual-price {
      direction: ltr;
    }

    span {
      margin-right: 5px;
    }
  }
` as any;
